import React from 'react';
import TradeJobFormView from './TradeJobFormView';
import { useAuth } from '../../AuthProvider';

export default function TradeJobCreatePage() {
  const auth = useAuth();
  return (
    <div style={{ padding: 16 }}>
      <h2>Create a Trade Job</h2>
      <TradeJobFormView
        open={true}
        onClose={() => {}}
        onSaved={() => {}}
        token={auth?.token}
        additionalUserInfo={auth?.additionalUserInfo}
        initialJob={null}
        presetLocationId={null}
        asPage={true}
      />
    </div>
  );
}
